const toggleShowClass = () => ({
    selectAll: false,
    checkbox: [],

    toggleClasses(event) {
        if (event.target !== this.$refs.nfcToggle) this.$refs.nfcToggle.checked = false;

        if (event.target === this.$refs.nfcToggle && event.target.checked) {
            this.selectAll = !this.selectAll;
            this.checkbox = [];
        }
    }
});

export default function browser() {
    window.nfcHandler = toggleShowClass;
}



// WEBPACK FOOTER //
// ./resources/js/frontend/components/toggleShowClasses.js